import { Route } from '@angular/router';
import { authGuard } from '../../guards/auth-guard/auth-guard';

export const consentGrantedRoute: Route = {
  path: 'consent-granted',
  loadChildren: () => import('../../../components/consent-granted/consent-granted.module').then(m => m.ConsentGrantedModule),
  canActivate: [authGuard],
};
